import React, { useState } from "react";
import "./Inquire_Now.css";
import { Button, Form, InputGroup } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import { useForm } from "react-hook-form";

function Inquire_Now() {
  const [showForm, setShowForm] = useState(false); // State to toggle visibility
  const { control, handleSubmit, getValues, setValue } = useForm();

  const handleToggle = () => {
    setShowForm((prev) => !prev); // Toggle the visibility state
  };

  return (
    <>
      <section className="Inquire_Now">
        <div className="container">
          <div className="content_holder">
            <div className="text_holder">
              <h2>Ready to Elevate Your Advertising? </h2>
              <h1>Inquire Now!</h1>
            </div>

            {showForm && ( // Conditionally render the form based on state
              <div className="row justify-content-center">
                <div className="col-xl-6 col-md-10">
                  <div className="main-form-div">
                    <div className="form">
                      <Form>
                        <div className="main-form-section mt-4">
                          <div className="input-div">
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  placeholder="Your Name"
                                />
                              </InputGroup>
                            </Form.Group>
                          </div>

                          <div className="input-div">
                            <Form.Group>
                              <InputGroup>
                                <Form.Control type="text" placeholder="Email" />
                              </InputGroup>
                            </Form.Group>
                          </div>

                          <div className="input-div">
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  placeholder="Subject"
                                />
                              </InputGroup>
                            </Form.Group>
                          </div>

                          <div className="input-div">
                            <Form.Group>
                              <div style={{ position: "relative" }}>
                                <PhoneInput
                                  country={"in"}
                                  placeholder="Enter Mobile Number"
                                  value={getValues("contact_no")}
                                  onChange={(phone) =>
                                    setValue("contact_no", phone)
                                  }
                                  inputProps={{
                                    searchPlaceholder: "Enter Mobile Number",
                                  }}
                                />
                              </div>
                            </Form.Group>
                          </div>

                          <div className="input-div">
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  placeholder="Your Message"
                                />
                              </InputGroup>
                            </Form.Group>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="btn_div">
              <Button className="submit_btn" onClick={handleToggle}>
                {showForm ? "Send Message" : "Send Message"} {/* Toggle button text */}
              </Button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Inquire_Now;
